import { render, staticRenderFns } from "./caiwu.vue?vue&type=template&id=368fa860&scoped=true"
import script from "./caiwu.vue?vue&type=script&lang=js"
export * from "./caiwu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368fa860",
  null
  
)

export default component.exports